"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Locked_exports = {};
__export(Locked_exports, {
  default: () => Locked_default
});
module.exports = __toCommonJS(Locked_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 3.58984C11.3854 3.58984 12.1471 3.88281 12.7852 4.46875C13.4362 5.05469 13.7812 5.76432 13.8203 6.59766L13.8398 6.75391V8.58984H14.25C14.6016 8.58984 14.8945 8.70703 15.1289 8.94141C15.3763 9.16276 15.5 9.44271 15.5 9.78125V15.7188C15.5 16.0573 15.3763 16.3438 15.1289 16.5781C14.8945 16.7995 14.6016 16.9102 14.25 16.9102H6.75C6.39844 16.9102 6.09896 16.7995 5.85156 16.5781C5.61719 16.3438 5.5 16.0573 5.5 15.7188V9.78125C5.5 9.44271 5.61719 9.16276 5.85156 8.94141C6.09896 8.70703 6.39844 8.58984 6.75 8.58984H7.16016V6.75391L7.17969 6.55859C7.23177 5.72526 7.57682 5.02214 8.21484 4.44922C8.85286 3.8763 9.61458 3.58984 10.5 3.58984ZM10.5 4.85938C9.96615 4.85938 9.51042 5.03516 9.13281 5.38672C8.75521 5.72526 8.54688 6.14193 8.50781 6.63672V6.75391V8.58984H12.4922V6.75391V6.57812C12.4401 6.09635 12.2253 5.69271 11.8477 5.36719C11.4701 5.02865 11.0208 4.85938 10.5 4.85938Z",
      fill: "currentColor"
    }
  )
);
const SvgLocked = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Locked_default = SvgLocked;
